import { DashworksReconnectButton } from './DashworksReconnectButton';
import { AppConnectionStatuses } from '../../../../constants/appConnectionStatuses';
import { DashworksServiceComponent } from './DashworksServiceComponent';
export const DashworksReconnectionConfig = {
  reconnectButton: DashworksReconnectButton,
  statusesForDisplaying: [AppConnectionStatuses.UPDATE_AVAILABLE, AppConnectionStatuses.DISCONNECTED],
  serviceComponent: DashworksServiceComponent
};